import { Component, ChangeDetectionStrategy, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { PaginatedSearchResultTeamSearchResultDTO } from '@solverml/api';
import { StatisticsStateService } from '../../controller/statistics-state.service';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-search-tab-team',
  templateUrl: './search-tab-team.component.html',
  styleUrls: ['./search-tab-team.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterLink,
    MatPaginatorModule,
    MatListModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinner
  ]
})
export class SearchTabTeamComponent {
  @Input() statsMode: 'actas' | 'ia' = 'actas';

  private state = inject(StatisticsStateService);

  // Observables para la UI
  public teamsResult$: Observable<PaginatedSearchResultTeamSearchResultDTO | null>;
  public isLoading$: Observable<boolean>;
  constructor() {
    this.teamsResult$ = this.state.teamsResult$;
    this.isLoading$ = this.state.isLoadingData$;
  }

  /**
   * Gestiona el evento de cambio de página del paginador.
   * Llama al StateService para buscar la nueva página.
   */
  public handlePageEvent(e: PageEvent): void {
    this.state.paginateTeams(e.pageIndex + 1);
  }
}
